import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/components';
import { FormsModule } from '@angular/forms';
import { AppLocaleManagerService } from '@wms/i18n';
import { isEmpty } from 'lodash-es';

@Component({
  selector: 'wms-locale-formats-tab',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './locale-formats-tab.component.html',
  styleUrls: ['./locale-formats-tab.component.less']
})
export class LocaleFormatsTabComponent extends BaseComponent implements OnInit {

  constructor(public appLocaleService: AppLocaleManagerService) {
    super();
  }

  ngOnInit(): void {
  }

  editFormat($evt: any, format?: any) {
    let secondaryLocale,
      currentFormat = this.appLocaleService.activeFormat && this.appLocaleService.activeFormat.format;
    $evt.stopPropagation();
    //do not allow editing existing messages if already editing new message is in progress
    this.appLocaleService.showLocaleAction = true;
    if (this.appLocaleService.addInProgress) {
      this.appLocaleService.toggleMessage(true, this.locale.MESSAGE_APP_MESSAGES_DIALOG_ADD_UNSTABLE_ERROR, 'error');
      return;
    }
    this.appLocaleService.toggleMessage(false);
    if (!isEmpty(this.appLocaleService.activeFormat) && currentFormat) {
      if (!this.appLocaleService.userFormats.en[currentFormat]) {
        this.appLocaleService.userFormats.en[currentFormat] = this.appLocaleService.systemFormats.en[currentFormat];
      }
      if (this.appLocaleService.multipleLocaleExists) {
        secondaryLocale = this.appLocaleService.selectedTempLocale.key;
        if (!this.appLocaleService.userFormats[secondaryLocale][currentFormat]) {
          this.appLocaleService.userFormats[secondaryLocale][currentFormat] = this.appLocaleService.systemFormats[secondaryLocale][currentFormat];
        }
      }
    }
    this.updateActiveFormat(format, secondaryLocale);
  }

  updateActiveFormat = (format: any, secondaryLocale: any) => {
    this.appLocaleService.activeFormat = {}; //empty the active message when edit is triggered and then assign respective message to true
    this.appLocaleService.activeFormat.format = format;
    this.appLocaleService.activeFormat.oldValues = {};
    if (format) { //when clicked on message key
      this.appLocaleService.activeFormat.en = {};
      this.appLocaleService.activeFormat.en[format] = true;
      this.appLocaleService.activeFormat.oldValues.en = this.appLocaleService.userFormats.en[format] || this.appLocaleService.systemFormats.en[format];
      if (this.appLocaleService.multipleLocaleExists) {
        secondaryLocale = this.appLocaleService.selectedTempLocale.key;
        this.appLocaleService.activeFormat.oldValues[secondaryLocale] = this.appLocaleService.userFormats[secondaryLocale][format] || this.appLocaleService.systemFormats[secondaryLocale][format];
        this.appLocaleService.activeFormat[secondaryLocale] = {};
        this.appLocaleService.activeFormat[secondaryLocale][format] = true;
      }
    }
  }
}
